import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import type { AgentOptions } from "@newrelic/browser-agent/loaders/agent";

type AttributeType = string | number | boolean | null | undefined;

declare global {
  interface Window {
    newrelic?: {
      addPageAction?: (
        name: string,
        attributes?: Record<string, AttributeType>,
      ) => void;
      noticeError?: (
        error: Error,
        attributes?: Record<string, AttributeType>,
      ) => void;
    };
  }
}

const options = {
  info: {
    applicationID: "1134675868",
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    licenseKey: "NRJS-81e40e6e56062c36166",
    sa: 1,
  },
  init: {
    ajax: {
      deny_list: ["bam.nr-data.net"],
    },
    browser_consent_mode: {
      enabled: false,
    },
    distributed_tracing: {
      enabled: true,
    },
    page_action: {
      enabled: true,
    },
    performance: {
      capture_detail: false,
      capture_marks: false,
      capture_measures: true,
    },
    privacy: {
      cookies_enabled: true,
    },
  },
  loader_config: {
    accountID: 3065011,
    agentID: 1134675868,
    applicationID: "1134675868",
    licenseKey: "NRJS-81e40e6e56062c36166",
    trustKey: 3065011,
  },
  exposed: true,
} satisfies AgentOptions;

const agent = new BrowserAgent(options);

export const isRouteDebugEnabled =
  import.meta.env.VITE_MODE === "development" ||
  import.meta.env.VITE_MODE === "debug";

export const trackNewRelicPageAction = (
  name: string,
  attributes: Record<string, string | number | boolean | null | undefined>,
): void => {
  agent?.addPageAction?.(name, attributes);
};
